import { Component } from '@angular/core';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-api-info',
  standalone: true,
  imports: [PageLayoutComponent],
  templateUrl: './api-info.component.html',
  styleUrl: './api-info.component.scss',
})
export class ApiInfoComponent {
  //

  code = `async function queryAPI() {

  // Get Auth Token
  const rootUrl = '${environment.API_BASE_URL}';
  const username = '[USERNAME]';
  const password = '[PASSWORD]';

  const response = await fetch(rootUrl + '/api/auth', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(authData),
  });

  const authStatus = response.status;
  const data = await response.json();
  if (authStatus !== 200) {
    console.log('Authentication failed: ', data);
    return;
  }
  const token = data.token;


  // Use token to make a query
  const dataResponse = await fetch(rootUrl + '/api/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: \`Bearer \${token}\`,
    },
    body: JSON.stringify({ query: 'SELECT * FROM mpc_orbits LIMIT 10;' }),
  });

  const data2 = await dataResponse.json();
  console.log(response2.status, JSON.stringify(data2, null, 2));
}

queryAPI();`;

  exampleMetaDatum = `
  {
    "job_id": "admin-1734396461.6923933-46247c4fe6fb17eff4ade944644f877c0c3ede1c7a7b3c736cd6a00e9bc7857b",
    "query": "SELECT * FROM mpc_orbit LIMIT 100;",
    "status": "queued",
    "creation_time": "1734396461.6924212",
    "error_message": null
  }
`;
}
